import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, Group, ModalSize, User } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { GroupComponent } from './group.component'

@Component({
    templateUrl: './groups.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class GroupsComponent extends BaseComponent {
    faSearch = faSearch
    groupsGrid: Grid<Group>
    usersGrid: Grid<User>

    criteriaData: any
    vistaUsers: any[] = []
    active = 1

    positionCodeMap!: DataMap
    prGroupMap!: DataMap
    earnCodeMap!: DataMap
    prDeptMap!: DataMap

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.HrGroupsEdit])
    }

    constructor() {
        super()
        this.groupsGrid = new Grid<Group>(this.services)
            .setupModalEditing(this.services.data.groups, 'Group', GroupComponent, () => new Group(), this, ModalSize.extraLarge)
            .filterBy(item => [item.name])
        this.groupsGrid.canEdit = this.canEdit
        this.usersGrid = new Grid<User>(this.services).filterBy(item => [item.name]).wrapColumnHeaders()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.groups.queryAll(),
                    this.services.data.users.queryAll(),

                    // Get the vista users to display the additional sorting properties (e.g. PRGroup, EarnCode, etc.)
                    this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', true)),
                    this.services.data.get('api/Group/GetGroupCriteriaOptions'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.groupsGrid.items = this.services.data.groups.items

                        // Add the additional sorting properties to the users
                        this.vistaUsers = result[2]
                        this.services.data.users.items.forEach(user => {
                            const vistaUser = this.vistaUsers.find(x => x.id === user.hrRef)
                            if (vistaUser) {
                                user.prgroup = vistaUser.prgroup
                                user.earnCode = vistaUser.earnCode
                                user.stdCraft = vistaUser.stdCraft
                                user.stdClass = vistaUser.stdClass ? vistaUser.stdCraft + '/' + vistaUser.stdClass : ''
                                user.prdept = vistaUser.prdept
                                user.jobTitle = vistaUser.jobTitle
                                user.positionCode = vistaUser.positionCode
                            }
                        })
                        this.criteriaData = result[3]

                        this.positionCodeMap = new DataMap(this.criteriaData.positionCodes, 'key', 'value')
                        this.prGroupMap = new DataMap(this.criteriaData.prGroups, 'key', 'value')
                        this.earnCodeMap = new DataMap(this.criteriaData.earnCodes, 'key', 'value')
                        this.prDeptMap = new DataMap(this.criteriaData.prDept, 'key', 'value')
                    },
                }),
        )
    }

    getUsersforGroup() {
        if (!this.groupsGrid.selectedItem) return
        this.cancelableRequest(
            'GetGroupUsers',
            true,
            this.services.data
                .load(true, true, this.services.data.post('api/Group/GetGroupUsers', [this.groupsGrid.selectedItem.id]))
                .subscribe({
                    next: result => {
                        const users = result[0] as User[]
                        users.forEach(user => {
                            const vistaUser = this.vistaUsers.find(x => x.id === user.hrRef)
                            if (vistaUser) {
                                user.prgroup = vistaUser.prgroup
                                user.earnCode = vistaUser.earnCode
                                user.stdCraft = vistaUser.stdCraft
                                user.stdClass = vistaUser.stdClass ? vistaUser.stdCraft + '/' + vistaUser.stdClass : ''
                                user.prdept = vistaUser.prdept
                                user.jobTitle = vistaUser.jobTitle
                                user.positionCode = vistaUser.positionCode
                            }
                        })
                        this.usersGrid.items = result[0]
                    },
                }),
        )
    }
}
